import { Component, Input, ViewEncapsulation } from "@angular/core";
import { ProductLocationAssortmentStatus } from "src/app/enum";
import { Guid } from "src/app/util/Guid";
import { Owner, OwnerLocation, ProductLocationsBase } from "../product-locations-base";

@Component({
  selector: "product-locations-popup",
  templateUrl: "./product-locations-popup.component.html",
  styleUrls: ["../product-locations.scss"],
  encapsulation: ViewEncapsulation.None
})
export class ProductLocationsPopupComponent extends ProductLocationsBase {
  @Input() public showSummaryText = true;

  public tooltipAccordionOpenOwnerIds: string[] = [];

  private ownerDiffs: any;

  ngOnInit() {
    if (this.locations && this.showSummaryText) {
      this.locationCount = this._calculateLocationCount(this.locations);
      this.ownerDiffs = this._calculateOwnerDiffs(this.locations);
      this.locationDiff = this._calculateTotalLocationDiff(this.ownerDiffs);
    }
  }

  public toggleOwnerExpand(owner: Owner): void {
    const index = this.tooltipAccordionOpenOwnerIds.indexOf(owner.ownerId);

    if (index > -1) {
      this.tooltipAccordionOpenOwnerIds = [];
    } else {
      this.tooltipAccordionOpenOwnerIds = [owner.ownerId];
    }
  }

  public getOwnerLocationDiff(owner: Owner): string {
    return this.ownerDiffs[owner.ownerId] || 0;
  }

  public getStatusClass(
    status: ProductLocationAssortmentStatus
  ): string | null {
    if (!this.showSummaryText) {
      return null;
    }

    switch (status) {
      case ProductLocationAssortmentStatus.Added:
        return "added";
      case ProductLocationAssortmentStatus.Removed:
        return "removed";
      case ProductLocationAssortmentStatus.NoChange:
        return "no-change";
      default:
        return null;
    }
  }

  private _calculateLocationCount(locations: Owner[]): number {
    return locations.reduce(
      (acc: number, owner: Owner) =>
        acc +
        owner.locations.filter(
          (x) => x.status !== ProductLocationAssortmentStatus.Removed
        ).length,
      0
    );
  }

  private _calculateOwnerDiffs(locations: Owner[]): any {
    return locations.reduce((diffs: any, owner: Owner) => {
      diffs[owner.ownerId] = owner.locations.reduce(
        (acc: number, loc: OwnerLocation) => this.calcDiff(acc, loc),
        0
      );
      return diffs;
    }, {});
  }

  private _calculateTotalLocationDiff(ownerDiffs: any): number {
    return Object.keys(ownerDiffs).reduce(
      (acc: number, key: string) => acc + ownerDiffs[key],
      0
    );
  }

}
